import React, {useCallback} from 'react';

import * as FilterActions from '../../../state/views/filter/actions';
import {type Ref} from '../../../state/views/filter/types';
import * as ViewHooks from '../../../state/views/hooks';
import {useViewAction} from '../../../state/views/hooks';
import type * as FilterTypes from '../../../util/filterTypes';
import {type FilterKeySelectorCreatorProps} from '../../Filters/FilterKeySelector';
import {WBTableActionFilterPicker} from '../WBTable/WBTableActionsFilter';
import {type RunFilterValueSelectorCreatorProps} from './RunsFilterValueSelector';

interface RunsFilterPickerProps {
  entityName: string;
  projectName: string;
  filtersRef: Ref;

  defaultToggleFilters?: FilterTypes.DefaultToggleFilter[];
  onFiltersChanged(): void;

  filterKeySelector(props: FilterKeySelectorCreatorProps): React.ReactNode;
  filterValueSelector(
    props: RunFilterValueSelectorCreatorProps
  ): React.ReactNode;
}

export const RunsFilterPicker = (props: RunsFilterPickerProps) => {
  const {filtersRef, onFiltersChanged, defaultToggleFilters} = props;
  const filters = ViewHooks.usePart(filtersRef);
  const setFilters = useViewAction(filtersRef, FilterActions.set);

  const setFiltersWrapped = useCallback(
    (...args: Parameters<typeof setFilters>) => {
      setFilters(...args);
      onFiltersChanged();
    },
    [setFilters, onFiltersChanged]
  );

  return (
    <WBTableActionFilterPicker
      filters={filters}
      defaultToggleFilters={defaultToggleFilters}
      setFilters={setFiltersWrapped}
      filterKeySelector={props.filterKeySelector}
      filterValueSelector={props.filterValueSelector}
    />
  );
};
